import { RETRY_NOT_QUEUED_REASONS } from "@signalist/shared-types";
import { z } from "zod";

/**
 * "Enrich anyway" recovery for title-excluded leads (PREC-3536 Phase 5). Counts are coerced —
 * SQL aggregates arrive as strings.
 */
export const EnrichAnywayResponseSchema = z.object({
	listId: z.coerce.number(),
	recovered: z.coerce.number(),
	whitelistedTitles: z.array(z.string()),
	queued: z.boolean(),
});

export type EnrichAnywayResponse = z.infer<typeof EnrichAnywayResponseSchema>;

export interface EnrichAnywayRequest {
	listId: number;
	listPersonIds: number[];
	whitelist: boolean;
}

/** Summary of the list-wide "retry not-found companies" action (plain retry, no discount). */
export const RetryNotFoundResponseSchema = z.object({
	listId: z.coerce.number(),
	retried: z.coerce.number(),
	queued: z.boolean(),
	byReason: z.record(z.string(), z.coerce.number()).optional(),
	// PREC-4520: why nothing was queued, so the message can say so instead of "started".
	notQueuedReason: z.enum(RETRY_NOT_QUEUED_REASONS).nullable().optional(),
	// PREC-4520: the other people the list's run would also search, each found one charged.
	pendingOthers: z.coerce.number().optional(),
});

export type RetryNotFoundResponse = z.infer<typeof RetryNotFoundResponseSchema>;
